/**
 * Quarterly fee snapshots fetched per account, cached for the page's lifetime.
 *
 * Same shape and TTL as txCache, but keyed on the account number alone — there
 * is no window dimension, since a snapshot is a closed quarter.
 *
 * Keyed per ACCOUNT rather than per family on purpose: two families that share
 * an account reuse the entry, opening a section only has to fetch the accounts
 * it doesn't already hold, and the silent reload after a transaction link can
 * invalidate exactly one account instead of the whole family.
 *
 * Module scope (not component state) so it survives the unmount a collapsing
 * row causes, and so the dashboard's Refresh can clear it.
 */
const feeSnapshotCache = new Map();

export const FEE_SNAPSHOT_CACHE_TTL_MS = 5 * 60 * 1000;

/** One account's cached snapshots while still fresh, else null. */
export const readFeeSnapshots = (accountNumber) => {
  const hit = feeSnapshotCache.get(String(accountNumber));
  if (!hit || Date.now() - hit.at >= FEE_SNAPSHOT_CACHE_TTL_MS) return null;
  return hit.snapshots;
};

export const writeFeeSnapshots = (accountNumber, snapshots) => {
  feeSnapshotCache.set(String(accountNumber), { snapshots, at: Date.now() });
};

export const invalidateFeeSnapshots = (accountNumber) => {
  feeSnapshotCache.delete(String(accountNumber));
};

export const clearFeeSnapshotCache = () => feeSnapshotCache.clear();
